import { AxiosError } from "axios"

type ErrorContent = {
  [errorType: string]: string
}

export type ErrorLogs = {
  title: string
  content: ErrorContent
}

export type RawOperationsFileError = {
  type: string
  lines: string
}

export const formatVerifyRawOperationsFileError = (
  error: AxiosError<object | string>
): RawOperationsFileError[] => {
  console.error({ error })
  const responseError = error.response?.data
  const message =
    typeof responseError !== "string" &&
    responseError &&
    "message" in responseError &&
    typeof responseError.message === "string"
      ? responseError.message
      : error.message
  try {
    const parsedError = JSON.parse(message) as ErrorLogs
    return Object.entries(parsedError.content).map(([type, lines]) => ({
      type,
      lines,
    }))
  } catch {
    return [{ type: "unknown", lines: message }]
  }
}
